import EditorImg from 'lowcode/components/EditorImg';
import { FC } from 'react';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import EditorLink from 'lowcode/components/EditorLink';
import { useMembersStore } from '../../../MembersProvider';
import styled from './index.module.scss';
import { IProductItem, ProductModule } from '@/components/MembersDay/type';
import { useLang } from '@/i18n';
import getLocal from '@/app/utils/getLocal';
import { EuEcoCredits } from '@/components/MembersDay/FY2024/CommonElement/EuEcoCredits';
import gtm from '@/utils/gtm';
import { useGlobal } from '@/utils/useGlobal';
import { SAVE_SITES, NA_SITES } from '@/constants/membersday';
import { signupCookie } from '@/utils/cookies/signupCookie';

interface IProps {
    data: IProductItem;
    list_name?: string;
    passLogin?: boolean; // au的Accessories模块 特殊处理 表现为 1. 未登录可加购 2. 没有角标
    module?: string; // 模块名称,判断产品模块
}

const CommonCardA: FC<IProps> = ({ data, list_name, passLogin = false, module }) => {
    const { Link } = useGlobal();
    const { t } = useLang('membersday.activity');
    const { isLogin } = useMembersStore();
    const { locale } = getLocal();

    const buyHandle = () => {
        if (isLogin || passLogin || NA_SITES.includes(locale)) {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name,
                product_name: data.title,
                price: data.memberPrice,
                tag: 'none',
                quantity: 1,
                button_name: t('product_price_buy_now'),
            });
            editorEventsBus.emit('ShopifyCart-add', data);
        } else {
            gtm.push({
                event: 'uaEvent',
                event_name: 'ecocredits_join_login',
                list_name,
                button_name: t('product_price_buy_now'),
            });
            const pathname2 = location.pathname;
            signupCookie?.({
                sector_name: data.title,
                entry_position: 3,
            });
            location.href = `/${locale}/login?redirect=${pathname2}`;
        }
    };

    const buttonHtml = () => {
        if (locale === 'kr') {
            return (
                <div className="tools">
                    <EditorLink style={{ width: '100%' }} href={data.productUrl} target="_blank">
                        <button className="card-btn learnmore-btn">{t('product_price_learn_more')}</button>
                    </EditorLink>
                    {/* 单独给kr这个模块加上 sold_out的按钮 */}
                    {module && module === ProductModule.NORMAL2 && data.inventoryQuantity === 0 ? (
                        <button className="card-btn" disabled>
                            {t('flashsale.sold_out')}
                        </button>
                    ) : (
                        <button className="card-btn" onClick={buyHandle}>
                            {t('product_price_buy_now')}
                        </button>
                    )}
                </div>
            );
        }
        if (!data.checkoutNode) {
            return (
                <EditorLink style={{ width: '100%' }} href={data.productUrl} target="_blank">
                    <button className="card-btn 78899">{t('product_price_learn_more')}</button>
                </EditorLink>
            );
        }
        return (
            <button className="card-btn" onClick={buyHandle}>
                {t('product_price_buy_now')}
            </button>
        );
    };

    return (
        <div className={`${styled.content} CommonCardA`}>
            <div>
                <EditorImg pc={data.imageUrl} />
                {data.discount && !passLogin && (
                    <div className="off">
                        {SAVE_SITES.includes(locale) ? (
                            data.discount
                        ) : (
                            <>
                                {data.discount}
                                &nbsp;
                                <span>{t('off')}</span>
                            </>
                        )}
                    </div>
                )}
                <div className="card-msg-box">
                    <EuEcoCredits />
                    <Link traget="_blank" href={data.productUrl}>
                        <div className="card-title">
                            {NA_SITES.includes(locale) ? 'EcoFlow ' : ''}
                            {data.title.replace(`(${t('product_price_member')})`, '')}
                        </div>
                    </Link>
                    {data.subtitle1 && <p className="card-subtitle">{data.subtitle1}</p>}
                    {data.subtitle2 && <p className="card-subtitle">{data.subtitle2}</p>}
                </div>
            </div>
            <div className="card-msg-box">
                <div className="card-price-a">
                    <div className="card-price-a-l">{data.memberPrice2}</div>
                    {['us', 'ca'].includes(locale) ? (
                        <span className="card-price-a-r">{t('product_price_member')}</span>
                    ) : Number(data.price) > Number(data.memberPrice) ? (
                        <span className="card-price-a-r">{t('product_price_member')}</span>
                    ) : (
                        Number(data.compareAtPrice) > Number(data.price) && <div className="card-price-c">{data.compareAtPrice2}</div>
                    )}
                </div>
                {Number(data.price) > Number(data.memberPrice) && (
                    <>
                        <div className="card-price-b">
                            {data.price2}&nbsp;<span className="card-price-b-tips">{t('product_price_non_member')}</span>
                        </div>{' '}
                        {!['us', 'ca'].includes(locale) && Number(data.compareAtPrice) > Number(data.price) && (
                            <div className="card-price-c">{data.compareAtPrice2}</div>
                        )}
                    </>
                )}
                {['us', 'ca'].includes(locale) && Number(data.compareAtPrice) > Number(data.price) && (
                    <div className="card-price-c">{data.compareAtPrice2}</div>
                )}
                {buttonHtml()}
            </div>
        </div>
    );
};

export default CommonCardA;
